export default __webpack_public_path__ + "static/media/old_logo_highlighted.dccfe580.png";